// extracted by mini-css-extract-plugin
export default {"next":"NextButton_next__ubHiI"};